import { clsx } from 'clsx';
import { type ComponentPropsWithRef, type ReactNode } from 'react';

import s from '../Input.module.css';

export type InputFieldProps = ComponentPropsWithRef<'div'> & {
  className?: string;
  children?: ReactNode;
};

export const InputField = (props: InputFieldProps) => {
  const { children, className, ...attrs } = props;

  return (
    <div className={clsx(s.field, className)} {...attrs}>
      {children}
    </div>
  );
};
